module.exports = require("@grpc/proto-loader");